<script>

import axios from 'axios';

export default class GruposRepository{
    
    async getGroupMembers(token,page){
        const baseURL = page
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const response = await axios.get(baseURL,{headers:headers});
        return response;

    }

}
</script>
